// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xndzk","content":"styles_content__3_oSg"};